import firebase from "firebase/compat/app";
import "firebase/compat/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC0wz02EN8E6pgUCm9q-R-GhQ-NopuC-ik",
  authDomain: "pzr-lccutracker.firebaseapp.com",
  projectId: "pzr-lccutracker",
  storageBucket: "pzr-lccutracker.appspot.com",
  messagingSenderId: "87969819792",
  appId: "1:87969819792:web:5e2259f34b615887c63c15",
  vapidKey:
    "BAmrHh6_m5znpVo9-XYPgrCpmHEJQJXjBnifzn2hknm-Yvbt_6o7gVMGmzLcRagOQO0IyofmfRAFngZHCcmFzIE",
  databaseURL:
    "https://pzr-lccutracker-default-rtdb.europe-west1.firebasedatabase.app",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging();

export const requestNotificationPermission = () => {
  return Notification.requestPermission()
    .then((permission) => {
      if (permission === "granted") {
        console.log("Notification permission granted.");
        return messaging.getToken({ vapidKey: firebaseConfig.vapidKey });
      } else {
        throw new Error("Notification permission not granted.");
      }
    })
    .then((token) => {
      console.log("FCM Token:", token);
      // Send the token to your server and save it
      return fetch("/api/save-token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token }),
      });
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      console.log("Token saved successfully:", data);
    })
    .catch((error) => {
      console.error("Error getting FCM token:", error);
    });
};
